import React, { Component } from 'react'
import { connect }          from 'react-redux'
import GeoDialog            from './../GeoDialog';
import { geoInformed }      from './../../../actions/GeoLocationAction';

class GeoDialogContainer extends Component
{

    render = () => 
    {
        return (
            <GeoDialog
                geo={ this.props.geo }
                onClose={ this.props.geoInformed }
            />
        );
    }

}

const mapStateToProps = (state) =>
{
    return {
        geo: state.geo
    };
};

const mapDispatchToProps = (dispatch) =>
{
    return {
        geoInformed: () =>
        {
            dispatch(geoInformed());
        }
    };
};

GeoDialogContainer = connect(mapStateToProps, mapDispatchToProps)(GeoDialogContainer);

export default GeoDialogContainer;


// WEBPACK FOOTER //
// ./src/components/Banner/containers/GeoDialogContainer.js